import React, { useState } from 'react';
import {
  Button,
  Dropdown,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { ChatDots, Envelope, Whatsapp } from 'react-bootstrap-icons';
import styles from './ContactButton.module.scss';

const CONTACT_EMAIL =
  process.env.REACT_APP_CONTACT_EMAIL || 'hola@mayorx.net';
const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '';
const DEFAULT_SUBJECT = 'Soporte / Ayuda - MayorX';
const WHATSAPP_MESSAGE = 'Hola, necesito ayuda con MayorX';

const ContactButton: React.FC = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const mailtoHref = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(DEFAULT_SUBJECT)}`;
  const whatsappHref = WHATSAPP_NUMBER
    ? `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, '')}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`
    : null;

  const handleEmail = () => {
    setShowDropdown(false);
    window.location.href = mailtoHref;
  };

  const handleWhatsApp = () => {
    setShowDropdown(false);
    if (whatsappHref) window.open(whatsappHref, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={styles.wrapper}>
      <OverlayTrigger
        placement="left"
        overlay={
          <Tooltip id="contact-tooltip">
            Reportar un error, pedir ayuda o contactar soporte
          </Tooltip>
        }
      >
        <Dropdown
          show={showDropdown}
          onToggle={setShowDropdown}
          drop="up"
          align="end"
        >
          <Dropdown.Toggle
            as={Button}
            variant="primary"
            className={styles.trigger}
            aria-label="Contactar soporte"
          >
            <ChatDots className={styles.triggerIcon} size={22} aria-hidden />
          </Dropdown.Toggle>
          <Dropdown.Menu className={styles.menu}>
            <Dropdown.Item onClick={handleEmail} className={styles.item}>
              <Envelope size={20} className={styles.icon} />
              Enviar email
            </Dropdown.Item>
            {whatsappHref && (
              <Dropdown.Item onClick={handleWhatsApp} className={styles.item}>
                <Whatsapp size={20} className={styles.icon} />
                WhatsApp
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </OverlayTrigger>
    </div>
  );
};

export default ContactButton;
